/**
 * Appends a post-signup destination to a quiz URL as the `nav` query param.
 * The quiz reads `nav` and redirects there once the quiz (and its inline signup)
 * completes — see pages/Quiz.tsx + pages/OnboardingQuiz.tsx. `postSignupUrl` is
 * an app path like "/events/some-event"; the leading slash is dropped because the
 * quiz navigates to `/${nav}`.
 */
export function withPostSignupNav(quizUrl: string, postSignupUrl?: string): string {
  if (!postSignupUrl) return quizUrl;
  const nav = postSignupUrl.replace(/^\//, "");
  const sep = quizUrl.includes("?") ? "&" : "?";
  return `${quizUrl}${sep}nav=${encodeURIComponent(nav)}`;
}
